(function () {
  function toggleFaqItem(header) {
    const faqItem = header.closest('.faq-item');
    if (!faqItem) return;

    const toggle = faqItem.querySelector('.faq-toggle');
    const content = faqItem.querySelector('.faq-answer-content');

    if (!toggle || !content) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      if (content.style.maxHeight === 'none') {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      requestAnimationFrame(() => {
        content.style.maxHeight = '0px';
      });

      toggle.setAttribute('aria-expanded', 'false');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');

      const onTransitionEnd = function (e) {
        if (e.propertyName !== 'max-height') return;

        if (toggle.getAttribute('aria-expanded') === 'true') {
          content.style.maxHeight = 'none';
        }

        content.removeEventListener('transitionend', onTransitionEnd);
      };

      content.addEventListener('transitionend', onTransitionEnd);
    }
  }

  document.addEventListener('click', function (e) {
    const header = e.target.closest('.faq-question-header');
    if (!header) return;

    e.preventDefault();
    toggleFaqItem(header);
  });
})();
